import {
  InfoDiscountCouponDto,
  InfoDiscountCoupon,
  CouponInfoData,
  CouponInfoDataDto,
  OneTimePremiumPlanDto,
  OneTimePremiumPlan,
  CustomerDetailsInfoPremiumDto,
  CustomerDetailsInfoPremium,
} from '$domain/model/premium/premium.model'
import * as dayjs from 'dayjs'

const mapOneTimePremiumPaymentDtoToView = selectedPlan => {
  if (selectedPlan === OneTimePremiumPlanDto.oneWeek) {
    return OneTimePremiumPlan.oneWeek
  }
  if (selectedPlan === OneTimePremiumPlanDto.oneMonth) {
    return OneTimePremiumPlan.oneMonth
  }
  if (selectedPlan === OneTimePremiumPlanDto.oneYear) {
    return OneTimePremiumPlan.oneYear
  }

  return OneTimePremiumPlan.oneWeek
}

export const mapOneTimePremiumPaymentToDto = selectedPlan => {
  if (selectedPlan === OneTimePremiumPlan.oneWeek) {
    return OneTimePremiumPlanDto.oneWeek
  }
  if (selectedPlan === OneTimePremiumPlan.oneMonth) {
    return OneTimePremiumPlanDto.oneMonth
  }
  if (selectedPlan === OneTimePremiumPlan.oneYear) {
    return OneTimePremiumPlanDto.oneYear
  }

  return ''
}

export const mapInfoDiscountCouponDtoToView = (infoCoupon: InfoDiscountCouponDto): InfoDiscountCoupon => {
  return {
    discountPercent: infoCoupon.discountPercent ? infoCoupon.discountPercent : 0,
    priceWithDiscount: infoCoupon.priceWithDiscount ? infoCoupon.priceWithDiscount : 0,
  }
}

const mapPlans = (validPlan: string[]) => validPlan.map(plan => mapOneTimePremiumPaymentToDto(plan))

export const mapCouponInfoDataToDto = (couponInfoData: CouponInfoData): CouponInfoDataDto => {
  return {
    couponCode: couponInfoData.couponCode ? couponInfoData.couponCode : '',
    validPlan: couponInfoData.validPlan.length > 0 ? mapPlans(couponInfoData.validPlan) : [],
    maxRedeems: couponInfoData.maxRedeems ? +couponInfoData.maxRedeems : 0,
    timeLimit: couponInfoData.timeLimit ? dayjs(couponInfoData.timeLimit).format() : '',
    discountPercent: couponInfoData.discountPercent ? +couponInfoData.discountPercent : 0,
    includesLongTerm: couponInfoData.includesLongTerm ? couponInfoData.includesLongTerm : false,
  }
}

export const mapCustomerDetailsInfoPremiumDtoToView = (
  detailsInfoPremium: CustomerDetailsInfoPremiumDto,
): CustomerDetailsInfoPremium => {
  return {
    selectedPlan: detailsInfoPremium.selectedPlan
      ? mapOneTimePremiumPaymentDtoToView(detailsInfoPremium.selectedPlan)
      : '',
    endDate: detailsInfoPremium.endDate ? detailsInfoPremium.endDate : '',
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/premium/premium.mapper.ts